import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import { TariffForm } from 'Services/ProductManagement/Features/Tariff/Components/TariffForm'
import { useSelectedTariff } from 'Services/ProductManagement/Features/Tariff/Hooks'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function TariffEditPage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs`

  const { id: tariffId } = useParams()
  const { singleTariff, isSingleTariffLoading } = useSelectedTariff(tariffId)
  const previousLocation = usePreviousLocation(`${baseUrl}/${tariffId}/details`)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Tariffs`,
      link: baseUrl
    },
    {
      title: singleTariff ? singleTariff.description : ''
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit tariff`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isSingleTariffLoading}>
        {singleTariff && <TariffForm tariff={singleTariff} successBaseUrl={previousLocation} />}
      </WithLoader>
    </Box>
  )
}
